<template>
  <div class="register">
    <the-navbar type="is-white"/>
    <div class="step-container">
      <div class="container" v-if="currentStep < 4">
        <div class="step" :class="{'is-active': currentStep === 1}">
          <p class="step-count">1</p>
          <p class="step-title">Informations sur le Centre de santé</p>
        </div>
        <div class="step" :class="{'is-active': currentStep === 2}">
          <p class="step-count">2</p>
          <p class="step-title">Informations sur le Responsable</p>
        </div>
        <div class="step" :class="{'is-active': currentStep === 3}">
          <p class="step-count">3</p>
          <p class="step-title">Informations sur la Secrétaire médicale</p>
        </div>
      </div>
    </div>
    <div class="form-container container">
      <div class="sections">
        <section class="section sidebar">
          <h1>{{ title }}</h1>
          <figure class="illustation">
            <img :src="illustration" :alt="title">
          </figure>
        </section>
        <section class="section content">
          <div class="form-wrapper">
            <component ref="form" :is="currentView"/>
          </div>
          <footer v-if="currentStep < 4">
            <button class="button is-outlined" v-if="currentStep > 1"
              @click="onPrevClicked">
              Retour
            </button>
            <button class="button is-primary" :class="{'is-loading': isLoading}"
              @click="onNextClicked">
              {{ nextButtonText }}
            </button>
          </footer>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TheNavbar from '@/components/TheNavbar'

import Utils from '@/utils'

const STEP_TITLES = [
  'Entrez les informations sur le Centre de santé',
  'Entrez les informations sur le Responsable',
  'Entrez les informations sur la Secrétaire'
]

export default {
  components: {
    TheNavbar
  },

  props: {
    step: {
      type: [String, Number],
      default: 1
    }
  },

  data () {
    return {
      isLoading: false
    }
  },

  computed: {
    ...mapGetters(['hospital', 'manager', 'secretary']),

    currentStep () {
      return parseInt(this.step)
    },

    currentView () {
      return require(`@/pages/register/step${this.step}`).default
    },

    nextButtonText () {
      return this.currentStep < 3 ? 'Suivant' : 'Terminer'
    },

    title () {
      return STEP_TITLES[this.currentStep - 1]
    },

    illustration () {
      return require(`@/assets/img/illus${this.step}.png`)
    }
  },

  watch: {
    '$route' () {
      this.checkStep()
    }
  },

  created () {
    this.checkStep()
    this.locateUser()
  },

  methods: {
    ...mapActions(['createHospital', 'locateUser', 'addHospital']),

    checkStep () {
      if (this.currentStep === 2 && !this.hospital.name) {
        return this.$router.replace({
          name: 'register',
          params: {
            step: 1
          }
        })
      }

      if (this.currentStep === 3 && !this.manager.firstname) {
        return this.$router.replace({
          name: 'register',
          params: {
            step: 2
          }
        })
      }
    },

    onPrevClicked () {
      this.$router.back()
    },

    async onNextClicked () {
      const validate = this.$refs.form.validate
      if (typeof validate === 'function') {
        this.isLoading = true
        const isValid = await validate()
        this.isLoading = false

        if (isValid) {
          if (this.currentStep < 3) {
            return this.$router.push({
              name: 'register',
              params: {
                step: '' + (this.currentStep + 1)
              }
            })
          }

          this.isLoading = true
          try {
            // await this.createHospital()
            const hospital = this.hospital
            hospital.contact = `${hospital.countryCode}${hospital.contact}`
            delete hospital.countryCode

            const manager = this.manager
            delete manager.email

            const secretary = this.secretary
            delete secretary.email

            const data = {
              hospital,
              manager,
              secretary
            }
            Utils.showConsoleLog({
              object: 'HOSPITAL DATA ',
              variableToLog: data
            })
            await this.addHospital(data)
            this.isLoading = false
            this.$router.push({name: 'register', params: {step: '4'}})
          } catch (error) {
            this.isLoading = false
            console.log('error', error)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .register {
    background-color: #e3ecf3;
  }

  .step-container {
    background-color: #2ba359;
  }
</style>



// WEBPACK FOOTER //
// src/pages/register.vue